import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=b3067c7c&"
import script from "./SocialMediaLinks.js?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports